import React from 'react';
import { COLORS } from '../../customer/Color';
import { useNavigate } from 'react-router-dom';

type DataType = {
  auction_idx: number;
  category: string;
  seq: number;
  title: string;
  write_time: string;
  article_idx: number;
};

type BoardRowProps = {
  data: DataType;
  index: number;
};

const NoticeList: React.FC<BoardRowProps> = ({ data }) => {
  const navigate = useNavigate();
  return (
    <div
      key={data.auction_idx}
      style={[
        styles.tableListRow,
        {
          backgroundColor: data.seq == 0 ? '#F7F8FC' : 'none',
        },
      ].reduce((acc, curr) => Object.assign(acc, curr), {})}
      onClick={() => {
        navigate(`/board/detail/${data.article_idx}`);
      }}
    >
      <div style={{ display: 'flex', flexDirection: 'row', gap: '8px' }}>
        {data.seq == 0 && (
          <span
            style={[
              styles.tableheaderText,
              {
                fontSize: '12px',
                backgroundColor: '#2868D2',
                color: '#FFFFFF',
                borderRadius: '9999px',
                padding: '2px 12px',
                textWrap: 'noWrap',
              },
            ].reduce((a, c) => Object.assign(a, c), {})}
          >
            중요
          </span>
        )}
        <span style={styles.tableheaderText}>{data.category}</span>
        <span style={styles.tableheaderText2}>{data.write_time}</span>
      </div>

      <div
        style={[styles.tableCol, { width: '80%' }].reduce(
          (a, c) => Object.assign(a, c),
          {},
        )}
      >
        <span
          style={[
            styles.tableheaderText,
            {
              width: '100%',
              textAlign: 'left' as const,
              fontSize: '18px',
              fontWeight: '700',
            },
          ].reduce((a, c) => Object.assign(a, c), {})}
        >
          {data.title}
          {(() => {
            const twoWeeksAgo = new Date();
            twoWeeksAgo.setDate(twoWeeksAgo.getDate() - 14);
            const writeDate = new Date(data.write_time);

            return writeDate >= twoWeeksAgo ? (
              <span
                style={{
                  marginLeft: '8px',
                  backgroundColor: '#2868D2',
                  color: '#FFFFFF',
                  borderRadius: '4px',
                  fontSize: '12px',
                  padding: '0px 4px',
                  fontWeight: '700',
                }}
              >
                N
              </span>
            ) : null;
          })()}
        </span>
      </div>
    </div>
  );
};

const styles = {
  section2: {
    display: 'flex',
    flexDirection: 'row' as 'row',
    gap: 24,
    width: '100%',
    paddingInline: '16px',
    paddingTop: '24px',
  },
  section3: {
    display: 'flex',
    flexDirection: 'column' as 'column',
  },
  section3header: {
    paddingTop: '32px',
    paddingBottom: '13px',
    paddingInline: '16px',
    display: 'flex',
    flexDirection: 'row' as 'row',
    justifyContent: 'space-between',
  },
  section3headerText: {
    fontFamily: 'Spoqa Han Sans Neo',
    fontSize: '20px',
    fontWeight: '700',
    lineHeight: '29px',
  },

  tableContainer: {
    display: 'flex',
    //paddingInline: '16px',
  },
  table: {
    display: 'flex',
    flexDirection: 'column' as 'column',
    width: '100%',
    flex: 1,
  },
  tableRow: {
    display: 'flex',
    padding: '16px',
    flexDirection: 'row' as 'row',
    backgroundColor: '#F7F8F9',
    width: '100%',
    marginBottom: '8px',
  },
  tableList: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column' as 'column',
  },
  tableListRow: {
    display: 'flex',
    flexDirection: 'column' as 'row',
    backgroundColor: '#F7F8F9',
    width: '100%',
    borderBottom: '1px solid #171E261A',
    borderBottomColor: '#171E261A',
    padding: '16px 24px',
    gap: '8px',
  },
  tableCol: {
    display: 'flex',
    flexWrap: 'wrap' as 'wrap',
    justifyContent: 'center',
    alignItems: 'center',
  },
  tableheaderText: {
    width: 'fit-content',
    fontFamily: 'Spoqa Han Sans Neo',
    fontSize: '16px',
    fontWeight: '500',
    lineHeight: '18.85px',
    color: '#222222',
    textAlign: 'center' as 'center',
  },
  tableheaderText2: {
    width: 'fit-content',
    fontFamily: 'Spoqa Han Sans Neo',
    fontSize: '16px',
    fontWeight: '500',
    lineHeight: '18.85px',
    color: '#616161',
    textAlign: 'center' as 'center',
  },
  listRowText: {
    width: '100%',
    fontFamily: 'Spoqa Han Sans Neo',
    fontSize: '13px',
    fontWeight: '500',
    lineHeight: '18.85px',
    color: '#171E268F',
    textAlign: 'center' as 'center',
  },
  dropdown: {
    minWidth: '109px',
    borderColor: COLORS.primary,
    border: '1px solid ' + COLORS.primary,
    borderRadius: 8,
    paddingBlock: '8px',
    paddingInline: '16px',
    backgroundColor: '#FFFFFF',
  },
  selectText: {
    fontFamily: 'Spoqa Han Sans Neo',
    fontSize: '13px',
    fontWeight: '500',
    lineHeight: '23.2px',
  },
  searchBox: {
    width: '720px',
    border: '1px solid #171E26',
    borderColor: '#171E26',
    borderRadius: 8,
    paddingBlock: '12px',
    paddingInline: '16px',
    display: 'flex',
    flexDirection: 'row' as 'row',
  },
  input: {
    fontFamily: 'Spoqa Han Sans Neo',
    fontSize: '13px',
    fontWeight: '500',
    lineHeight: '23.2px',
    textAlign: 'left' as 'left',
    width: '100%',
  },
  inputBox: {
    flex: 1,
    display: 'flex',
    flexDirection: 'row' as 'row',
    gap: 4,
  },
  section04: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column' as 'column',
    justifyContent: 'center',
    alignItems: 'flex-end',
    gap: 40,
    paddingTop: '16px',
    paddingInline: '16px',
  },
  writeBtn: {
    display: 'flex',
    flexDirection: 'row' as 'row',
    justifyContent: 'center',
    alignItems: 'center',
    gap: 8,
    border: '1px solid ' + COLORS.primary,
    borderColor: COLORS.primary,
    borderRadius: 8,
    width: '77px',
    height: '35px',
  },
  btnText: {
    fontFamily: 'Spoqa Han Sans Neo',
    fontSize: '13px',
    fontWeight: '500',
    lineHeight: '18.85px',
    color: COLORS.primary,
  },
  emptyMessage: {
    width: '100%',
    height: '200px',
    fontFamily: 'Spoqa Han Sans Neo',
    fontSize: '13px',
    fontWeight: '500',
    lineHeight: '18.85px',
    color: COLORS.disabled,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
};

export default NoticeList;
